import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { useUpdateConfig } from '~/domains/configuration/mutations/updateConfig'
import type { ConfigName } from '~/domains/configuration/types'
import { toast } from '~/utils'

export const useToggleConfigChange = (
  configName: ConfigName,
  /** A function lets the message name what was turned on, and what was turned off. */
  successMessage:
    | string
    | ((checked: boolean) => string) = 'Préférence mise à jour avec succès.'
) => {
  const { mutateAsync: updateConfig } = useUpdateConfig()

  return async (checked: boolean) => {
    try {
      await updateConfig({ name: configName, value: checked })
      toast(
        'Préférence mise à jour',
        typeof successMessage === 'function'
          ? successMessage(checked)
          : successMessage,
        ToastType.Success
      )
    } catch {
      toast(
        'Erreur',
        'Une erreur est survenue lors de la mise à jour.',
        ToastType.Danger
      )
    }
  }
}
